<template>
  <div>
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <v-card :loading="isLoading" id="account-setting-card">

      <!-- Mobile-friendly header -->
      <div class="profile-header">
        <v-btn icon small @click="$router.go(-1)" class="back-btn">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="profile-title" v-if="user">{{ user.name }}</span>
      </div>

      <div>
        <v-tabs v-model="tab" grow>
          <v-tab v-for="t in tabs" :key="t.icon">
            <v-icon size="18" class="me-1">{{ t.icon }}</v-icon>
            <span class="tab-label">{{ t.title }}</span>
          </v-tab>
        </v-tabs>

        <v-tabs-items touchless v-model="tab">
          <v-tab-item>
            <account-settings-account
              :account-data="user"
              :user-type="userType"
              @save-user-info="saveUser"
            ></account-settings-account>
          </v-tab-item>
          <v-tab-item>
            <account-settings-security
              @save-user-password="savePassword"
            ></account-settings-security>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from "vue-element-loading";
import { mdiAccountOutline, mdiLockOpenOutline } from "@mdi/js";
import { ref } from "@vue/composition-api";
import AccountSettingsAccount from "@/views/users/user-settings/AccountSettingsAccount.vue";
import AccountSettingsSecurity from "@/views/users/user-settings/AccountSettingsSecurity.vue";
import { adminProfileStore } from "@/utils/helpers";

export default {
  components: { AccountSettingsSecurity, AccountSettingsAccount, VueElementLoading },
  data() {
    return {
      isLoading: false,
      user: null,
      tabs: [
        { title: "Account", icon: mdiAccountOutline },
        { title: "Password", icon: mdiLockOpenOutline },
      ],
      tab: ref(""),
      userType: "driver",
    };
  },
  mounted() {
    this.fetchProfile();
  },
  methods: {
    fetchProfile() {
      this.loading = true;
      axios
        .get("/users/profile")
        .then((r) => { this.user = r.data; })
        .catch(() => {
          this.$notify({ title: "Error", text: "Error fetching user data", type: "error" });
        })
        .then(() => { this.isLoading = false; });
    },
    saveUser() {
      this.isLoading = true;
      axios
        .post("/users/update-profile", {
          name: this.user?.name,
          tel_number: this.user?.tel_number,
        })
        .then(() => {
          adminProfileStore.name = this.user.name;
          this.$notify({ title: "Success", text: "Profile updated!", type: "success" });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$notify({ title: "Error", text: "Error updating profile", type: "error" });
        })
        .then(() => { this.isLoading = false; });
    },
    savePassword(password) {
      this.isLoading = true;
      axios
        .post("/users/update-password", { user_id: this.user.id, password })
        .then(() => {
          this.$notify({ title: "Success", text: "Password updated!", type: "success" });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$notify({ title: "Error", text: "Error updating password", type: "error" });
        })
        .then(() => { this.isLoading = false; });
    },
  },
};
</script>

<style scoped>
.profile-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 8px;
  border-bottom: 1px solid rgba(0,0,0,0.06);
}
.back-btn {
  flex-shrink: 0;
}
.profile-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a2744;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tab-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
</style>
